<template>
    <v-dialog v-model="dialog" persistent max-width="560">
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          Get foxy with your ad creative
        </v-card-title>

        <v-card-text>
          We can connect you with vetted creative professionals to help you design captivating Facebook ads. E-mail us your project details at <a :href="`mailto:${mail}`">{{mail}}</a>, and we’ll be in touch!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDialog"
          >
            Thank you
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import DevPlaceholder from '../../../helpers/TheDevPlaceholder'
export default {
  name: 'voter-list',
  components: {
    DevPlaceholder
  },
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
      this.$emit('closeDialog')
    }
  }
}
</script>
